const setSelectedSkill = (state, skill) => {
    state.selectedSkill = skill;
};

export default {
    setSelectedSkill,
};



// WEBPACK FOOTER //
// ./src/taskflex/students/store/students/_mutators.js